import React, { useState } from 'react';
import { History, Trash2, ChevronRight, Clock } from 'lucide-react';

const ConversationHistory = ({ savedConcepts, onLoadConversation, onDeleteConcept }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!isExpanded) {
    return (
      <div className="w-12 bg-white border-r border-gray-200 flex flex-col items-center py-4">
        <button
          onClick={() => setIsExpanded(true)}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          aria-label="Expand sidebar"
        >
          <ChevronRight className="w-5 h-5 text-gray-600" />
        </button>
      </div>
    );
  }

  return (
    <div className="w-80 bg-white border-r border-gray-200 flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-gray-200 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <History className="w-5 h-5 text-gray-600" />
          <h2 className="font-semibold text-gray-900">Saved Concepts</h2>
        </div>
        <button
          onClick={() => setIsExpanded(false)}
          className="p-1 hover:bg-gray-100 rounded transition-colors"
          aria-label="Collapse sidebar"
        >
          <ChevronRight className="w-4 h-4 text-gray-600 rotate-180" />
        </button>
      </div>
      {/* Saved Concepts List */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {savedConcepts?.length === 0 ? (
          <div className="text-center py-12">
            <History className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <p className="text-sm text-gray-500">No saved concepts yet</p>
            <p className="text-xs text-gray-400 mt-1">
              Start a conversation and save concepts to see them here
            </p>
          </div>
        ) : (
          savedConcepts?.map((saved) => (
            <div
              key={saved?.id}
              className="bg-gray-50 rounded-lg p-3 hover:bg-gray-100 transition-colors cursor-pointer group"
              onClick={() => onLoadConversation(saved)}
            >
              <div className="flex items-start justify-between gap-2 mb-2">
                <h3 className="font-medium text-sm text-gray-900 line-clamp-2 flex-1">
                  {saved?.concept?.summary || 'Untitled Concept'}
                </h3>
                <button
                  onClick={(e) => {
                    e?.stopPropagation();
                    onDeleteConcept(saved?.id);
                  }}
                  className="opacity-0 group-hover:opacity-100 p-1 hover:bg-red-100 rounded transition-all"
                  aria-label="Delete concept"
                >
                  <Trash2 className="w-4 h-4 text-red-600" />
                </button>
              </div>

              <div className="flex items-center gap-2 text-xs text-gray-500">
                <Clock className="w-3 h-3" />
                <span>
                  {new Date(saved.timestamp)?.toLocaleDateString([], {
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </span>
              </div>

              {saved?.concept?.complexity && (
                <div className="mt-2">
                  <span
                    className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${
                      saved?.concept?.complexity === 'simple' ?'bg-green-100 text-green-800'
                        : saved?.concept?.complexity === 'medium' ?'bg-yellow-100 text-yellow-800' :'bg-red-100 text-red-800'
                    }`}
                  >
                    {saved?.concept?.complexity}
                  </span>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ConversationHistory;